import axios from 'axios';
interface LicenceResponse {
    data: {
      licence: string;
      remark: string,
      enable: string,
    },
    "status": number,
    "msg": string;
  }  

  interface LoginResponse {
    data: {
      jwt: string;
      customerPK: string,
      loginDate: string,
      token: string,
      enable: string,
    },
    "status": number,
    "msg": string;
  }

  interface WebUrlResponse {
    data: {
      id: number;
      licence: string,
      remark: string,
      enable: string,
    },
    "status": number,
    "msg": string;
  }

  interface WebUrlProcessResponse {
    data: {
      id: number;
      customerPK: string,
      email: string,
      domain: string,
      enable: string,
      expiryDate: string,
      processDate: string,
      licencePK: string,

    },
    "status": number,
    "msg": string;
  }

  interface ReportResponse {  // 重命名避免大写
    data: string;
    status: number;
    msg: string;
  }
  
class ClientService {
    private static instance: ClientService;
    private domain: string = '';  // 改为相对路径，通过代理转发；生产用环境变量如 process.env.API_BASE

    private constructor() {
        // Initialize from sessionStorage
    }

    // Add this method right after getInstance() at line 69
  private getDeviceId(): string {
    let deviceId = localStorage.getItem('deviceId');
    if (!deviceId) {
      deviceId = 'web-' + crypto.randomUUID();
      localStorage.setItem('deviceId', deviceId);
    }
    return deviceId;
  }

    public static getInstance(): ClientService {
        if (!ClientService.instance) {
            ClientService.instance = new ClientService();
        }
        return ClientService.instance;
    }
    public extractPromotionCode(url: string): string | null {
        try {
        const urlParams = new URLSearchParams(url.split('?')[1]);
        return urlParams.get('promo');
        } catch (error) {
        console.error('Error extracting promotion code:', error);
        return null;
        }
    }
    // 处理促销码验证
  public async handleValidation(code: string): Promise<{ success: boolean; licence?: string; error?: string }> {
    try {
      const jwt = sessionStorage.getItem('jwt');  // 或从 AuthService 获取
      const response = await axios.post<WebUrlResponse>(`${this.domain}/AICharlyCam/API/WebUrl/Validation`, {
        code: code,
        deviceId: this.getDeviceId(),
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(jwt && { 'Authorization': `Bearer ${jwt}` }),  // 条件添加，避免 null
        },
      });

      if (response.data.status === 200) {
        sessionStorage.setItem('code', code);
        return { success: true, licence: response.data.data.licence };
      } else {
        return { success: false, error: response.data.msg };
      }
    } catch (error) {
      return { success: false, error: this.handleError(error, 'invitationError') };
    }
  }

  // 处理流程
  public async handleProcess(code: string): Promise<string> {
    try {
      const jwt = sessionStorage.getItem('jwt');
      const response = await axios.post<WebUrlProcessResponse>(`${this.domain}/AICharlyCam/API/WebUrl/Process`, {
        code: code,
        deviceInfo: navigator.userAgent,
        deviceId: this.getDeviceId(),
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(jwt && { 'Authorization': `Bearer ${jwt}` }),
        },
      });

      if (response.data.status === 200) {
        sessionStorage.setItem('customerPK', response.data.data.customerPK);
        sessionStorage.setItem('email', response.data.data.email);
        return response.data.data.email;
      } else {
        return response.data.msg;
      }
    } catch (error) {
      return this.handleError(error, 'invitationError');
    }
  }

  // 处理报告
  public async handleReport(reportData: string): Promise<string> {
    try {
      const jwt = sessionStorage.getItem('jwt');
      const parsedData = JSON.parse(reportData);  // 假设 reportData 是 JSON 字符串
      const response = await axios.post<ReportResponse>(`${this.domain}/AICharlyCam/API/CreatePDF`, parsedData, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(jwt && { 'Authorization': `Bearer ${jwt}` }),
        },
      });

      if (response.data.status === 200) {
        sessionStorage.setItem('path', response.data.data);
        return response.data.data;
      } else {
        return response.data.msg;
      }
    } catch (error) {
      return this.handleError(error, 'Create Failure');
    }
  }

  public async handleLogin(username: string, password: string): Promise<string> {
    try {
      const jwt = sessionStorage.getItem('jwt');
      const response = await axios.post<LoginResponse>(`${this.domain}/AICharlyCam/API/Login`, {
        userName: username,
        password: password,
        deviceInfo: navigator.userAgent,
        deviceId: this.getDeviceId(),
        appVersion: '1.0.0'
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(jwt && { 'Authorization': `Bearer ${jwt}` }),
        },
      });

      if (response.data.status === 200) {
        // 假设后端返回 jwt；如果没有，需调整
        //sessionStorage.setItem('jwt', response.data.data.jwt || '');  // 添加 jwt 设置，与 AuthService 一致
        sessionStorage.setItem('customerPK', response.data.data.customerPK);
        sessionStorage.setItem('acrossToken', response.data.data.token);
        console.log('Login success:', { token: response.data.data.token, customerPK: response.data.data.customerPK });
        return '';
      } else {
        return response.data.msg;
      }
    } catch (error) {
      return this.handleError(error, 'UserName/Email or password is wrong.');
    }
  }

  // 处理许可
  public async handleLicence(): Promise<string> {
    try {
      const jwt = sessionStorage.getItem('jwt');
      const acrossToken = sessionStorage.getItem('acrossToken');
      const customerPK = sessionStorage.getItem('customerPK');
  
      // 新增：检查必需值
      if (!jwt || !acrossToken || !customerPK) {
        console.error('Missing auth tokens:', { jwt: !!jwt, acrossToken: !!acrossToken, customerPK });
        return 'Please login first.';  // 或重定向登录
      }
  
      console.log('Sending Licence request with:', { customerPK, jwt: jwt.substring(0, 20) + '...', acrossToken: acrossToken.substring(0, 20) + '...' });
  
      const response = await axios.post<LicenceResponse>(`${this.domain}/AICharlyCam/API/LicenceWeb`, {
        customerPK: customerPK
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${jwt}`,
          'acrossToken': acrossToken,
        },
      });
  
      console.log('Licence response:', response.data);  // 调试响应
  
      if (response.data.status === 200) {
        return response.data.data.licence;
      } else {
        return response.data.msg;
      }
    } catch (error) {
      return this.handleError(error, 'Licence fetch failed.');
    }
  }

  // 统一错误处理（提取公共逻辑）
  private handleError(error: unknown, defaultMsg: string): string {
    if (axios.isAxiosError(error) && error.response) {
      console.error('API Error:', { status: error.response.status, data: error.response.data });
      if (error.response.status === 400) {
        return defaultMsg;
      } else {
        return error.response.data?.msg || defaultMsg;
      }
    } else {
      console.error('Unexpected error:', error);
      return defaultMsg;
    }
  }
}

export default ClientService;